import { FuelSaverResultModelExtended } from 'app/models/dms/fuelSaverResult.model';
import { FuelSaverResultModel } from './fuelSaverResult.model';
import { PurchaseOrderResultModel } from './purchaseOrderResult.model';
import { OpportunityActivityResultModel } from './opportunityActivityResult.model';
import { VehicleImageModel } from './vehicleImage.model';
import { VehicleClass, LookupExternalCollection, LookupExtImageCollection } from 'app/utility/enums';
import { ListItemModel } from './../shared/listItem.model';
import { LookupExternalModel, LookupExtImageModel, LookupInternalModel, LookupModel } from "app/models/shared/lookup.model";
import { ContactModel } from "./contact.model";
import { ContactResultModel } from "./contact.model";
import { VehicleExpenseModel } from "./vehicleExpense.model";
import { TaxStatusEnum } from "app/utility/enums";
import { TaxStatusModel } from './taxStatus.model';
import { CustomFieldResultModel } from '../shared/customField.model';
import { DigitalSigningModel } from './digitalSigning.model';

export class VehicleGeneralModel
{
    public vehicleClass: VehicleClass;
    public vehicleId: string;

    public manufacturerId: string;
    public modelId: string;
    public variantId: string;
    public fuelSaverResult: FuelSaverResultModelExtended;
    public manuYear: string;
    public bodyStyleId: string;
    public chassisExtras: string;
    public chassisType: string;
    public constructTypeId: string;
    public adminFlagsRegisteredLocal: boolean;
    public regNo: string;
    public adminFlagsReRegisteredLocal: boolean;
    public regYearLocal: string;
    public stockNo: string;
    public vin: string;
    public chassisNo: string;
    public engineNo: string;
    public wheelbase: string;
    public boatLength: number;
    public boatBeam: number;
    public boatDraft: number;
    public caravanLength: number;
    public caravanWidth: number;
    public deckHeight: number;
    public deckWidth: number;
    public deckLength: number;
    public gvm: number;
    public tare: number;
    public glw: number;
    public gcw: number;
    public seatHeight: string;
    public groundClearance: string;
    public dryWeight: string;
    public fuelCapacity: string;
    public motorhomeLength: number;
    public motorhomeWidth: number;
    public hubSerialNo: string;
    public hubModelNo: string;

    //sideload objects
    public manufacturer: LookupModel;
    public model: LookupModel;
    public variant: LookupModel;
    public bodyStyle: LookupModel;
    public constructType: LookupModel;

}
export class VehicleLockStatusModel
{
    public locked: boolean;
    public lockdownCondition: string;
}

export class VehiclePurchaseModel
{
    public vehicleClass: VehicleClass;
    public vehicleId: string;

    public purchaseDate: Date;
    public purchaseTypeId: string;
    public purchaseSupplierName: string;
    public purchaseFlagsTraderAcquisitionApplies: boolean;
    public purchaseFlagsTraderAcquisitionCompleted: boolean;
    public purchaseDesc: string;
    public auctionGrade: string;
    public appraisalAmount: number;
    public appraisalAmountCaption: string;
    public appraisedById: string;
    public appraisalTaxAmount: number;
    public appraisalTaxRate: number;
    public appraisalTaxStatusEnum: number;
    public appraisalNotes: string;
    public deliveryPortId: string;
    public vesselName: string;
    public voyageName: string;
    public vesselDepartDate: Date;
    public portArrivalDate: Date;
    public yardArrivalDate: Date;
    public prevCountryId: string;
    public regYear: number;
    public purchaseFlagsImportedAsDamaged: boolean;
    public daysSincePurchase: string;
    public prevOwnerTypeId: string;
    public purchaseFlagsIsBrandNew: boolean;
    public prevOwnerNo: string;
    public purchaseFlagsHasSecurityInterest: boolean;
    public purchaseFlagsAutoCalcImportTax: boolean;

    public vehicleLandedCost: string;
    public vehicleLandedCostGst: number;
    public vehicleWriteBack: number;

    public saleCustomerPurchasePrimaryCaption: string;
    public saleVehiclePurchaseWritebackAmount: number;

    //sideload objects
    public purchaseType: LookupModel;
    public appraisedBy: ContactResultModel;
    public deliveryPort: LookupModel;
    public prevCountry: LookupModel;
    public prevOwnerType: LookupModel;

    public signingRequest: DigitalSigningModel;


}
export class VehicleExpensesModel
{

    //sideload objects

    public expenses: VehicleExpenseModel[];

    public summaryPurchaseCostsImportAmount: number; //double
    public summaryPurchaseCostsImportTaxAmount: number; //double
    public summaryPurchaseCostsLocalAmount: number; //double
    public summaryPurchaseCostsLocalTaxAmount: number; //double
    public summaryStandardExpenseAmount: number; //double
    public summaryStandardExpenseTaxAmount: number; //double
    public summaryStandardExpenseAmountExact: number; //double
    public summaryStandardExpenseTaxAmountExact: number; //double
    public summaryStandardExpenseAmountEstimate: number; //double
    public summaryStandardExpenseTaxAmountEstimate: number; //double
    public summaryAfterSaleExpenseAmount: number; //double
    public summaryAfterSaleExpenseTaxAmount: number; //double
    public summaryAfterSaleExpenseAmountExact: number; //double
    public summaryAfterSaleExpenseTaxAmountExact: number; //double
    public summaryAfterSaleExpenseAmountEstimate: number; //double
    public summaryAfterSaleExpenseTaxAmountEstimate: number; //double
    public summaryPurchaseCostsAmount: number; //double
    public summaryPurchaseCostsTaxAmount: number; //double
    public summaryTotalCostsAmount: number; //double
    public summaryTotalCostsAmountCaption: string; //double
    public summaryTotalCostsTaxAmount: number; //double
    public summaryGrossPriceAmount: number; //double
    public summaryGrossPriceTaxAmount: number; //double
    public grossPriceDisplay: string;
    public summaryNetPriceAmount: number; //double
    public summaryNetPriceTaxAmount: number; //double
    public summaryGrossTotalCostsAmount: number; //double
    public summaryGrossTotalCostsTaxAmount: number; //double
    public summaryNetTotalCostsAmount: number; //double
    public summaryNetTotalCostsTaxAmount: number; //double
    public summaryNetProfitAmount: number; //double
    public summaryNetProfitAmountCaption: string;
    public summaryNetProfitPercent: number; //double
    public summaryNetProfitPercentCaption: string;
    public summaryGrossProfitAmount: number; //double
    public summaryGrossProfitAmountCaption: string;
    public summaryGrossProfitPercent: number; //double
    public summaryGrossProfitPercentCaption: number; //double
    public summaryGrossProfitTaxAmount: number; //double
    public summaryGrossProfitTaxAmountCaption: string;
    public summaryTotalCostsTaxAmountCaption: string;
    public summaryImportPurchaseCostsAmountCaption: string;
    public summaryImportPurchaseCostsTaxAmountCaption: string;
    public summaryImportPurchaseCostsImportAmountCaption: string;
    public summaryImportPurchaseCostsLocalAmountCaption: string;
    public summaryLocalPurchaseCostsAmountCaption: string;
    public summaryLocalPurchaseCostsTaxAmountCaption: string;
    public summaryStandardExpenseAmountExactCaption: string;
    public summaryStandardExpenseAmountEstimateCaption: string;
    public summaryStandardExpenseAmountCaption: string;
    public summaryStandardExpenseTaxAmountCaption: string;
    public summaryGrossPriceNameCaption: string;
    public summaryGrossPriceAmountCaption: string;
    public summaryAfterSaleExpenseAmountCaption: string;
    public summaryImportPurchaseCostsImportTaxAmountCaption: string;
    public adminFlagsIsCleanVehicleFeeInclusive: boolean;
    public hasCleanVehicleFee: boolean;
    public cleanVehicleApplicableAmountCaption: string;

}
export class VehicleExteriorModel
{
    public vehicleClass: VehicleClass;
    public vehicleId: string;

    public extColor1Id: string;
    public extColor2Id: string;
    public doorNo: number;
    public sunroofId: string;
    public suspension: string;
    public brakes: string;
    public wheelSize: number;
    public wheelCompId: string;
    public wheelConfig: string;
    public tyreConfig: string;
    public tyreConditionId: string;
    public exteriorFeatureIds: string[];

    //sideload objects
    public extColor1: LookupModel;
    public extColor2: LookupModel;
    public sunroof: LookupModel;
    public wheelComp: LookupModel;
    public tyreCondition: LookupModel;
    public exteriorFeatureLookups: LookupModel[];

}
export class VehicleInteriorModel
{
    public vehicleClass: VehicleClass;
    public vehicleId: string;

    public intColor1Id: string;
    public intTrimId: string;
    public seatNo: number;
    public seatMaterialId: string;
    public audioFlagsCassettePlayer: boolean;
    public audioFlagsCDPlayer: boolean;
    public audioFlagsBandExpander: boolean;
    public airbagNo: number;
    public berthNo: number;
    public cabinNo: number;
    public interiorFeatureIds: string[];

    //sideload objects
    public intColor1: LookupModel;
    public intTrim: LookupModel;
    public seatMaterial: LookupModel;
    public interiorFeatureLookups: LookupModel[];

}
export class VehicleMechanicalModel
{
    public vehicleClass: VehicleClass;
    public vehicleId: string;

    public engineSize: string;
    public engineSizeUnitId: string;
    public engineType1Id: string;
    public fuelType1Id: string;
    public fuelType2Id: string;
    public cylinderNo: number;
    public turboId: string;
    public driveSystemId: string;
    public exhaustType: string;
    public engineDescription: string;
    public engineHours: number;
    public engineYear: string;
    public engineManuId: string;
    public engineModel: string;
    public engineHp: number;
    public engineNo: number;
    public engineTorqueId: string;
    public transmissionId: string;
    public transModel: string;
    public transManuId: string;
    public odoStatusId: string;
    public odoAddReading: boolean;
    public odoReading: number;
    public odoUnitId: string;
    public odoDate: Date;
    public latestOdoReadingCaption: string;
    public batPower: number;
    public batRange: number;
    public batHealth: number;
    public maxSpeed: number;
    public cruiseSpeed: number;
    public fuelCapacity: number;
    public waterCapacity: number;
    public mechanicalFlagsOdometerCertified: boolean;
    public mechanicalFlagsABSBraking: boolean;
    public mechanicalFlagsTractionControl: boolean;
    public mechanicalFeatureIds: string[];

    //sideload objects
    public engineSizeUnit: LookupModel;
    public engineType1: LookupModel;
    public fuelType1: LookupModel;
    public fuelType2: LookupModel;
    public turbo: LookupModel;
    public driveSystem: LookupModel;

    public engineManu: LookupModel;
    public engineTorque: LookupModel;
    public transmission: LookupModel;
    public transManu: LookupModel;
    public odoStatus: LookupModel;
    public odoUnit: LookupModel;
    public mechanicalFeatureLookups: LookupModel[];

}
export class VehicleExportModel
{
    public vehicleClass: VehicleClass;
    public vehicleId: string;

    public adminFlagsIncludeExport: boolean;
    public exportSpecIds: string;
    public adminFlagsIsFeaturedNeedacar: boolean;
    public adminFlagsIsFeatured: boolean;
    public adminFlagsIsSuperFeatured: boolean;
    public adminFlagsIsShowroomTradeMe: boolean;
    public chkAuctionExport: boolean;
    public auctionExportId: string;
    public startPriceAmount: number;
    public reservePriceAmount: number;
    public buyNowPriceAmount: number;
    public exportTitle: string;
    public exportTagline: string;
    public variantAlt: string;
    public stockNoAlt: string;
    public exportDescription: string;
    public displayOffer: boolean;
    public offerEndDate: Date;
    public offerText: string;
    public aiProvider: number;
    public aiQualified: boolean;
    public adminFlagsIsCINExcluded: boolean;

    //sideload objects
    public exportSpecsVals: LookupModel[];
    public vehicleOffer: LookupExternalModel;
}
export class VehicleAdminModel
{
    public vehicleClass: VehicleClass;
    public vehicleId: string;

    public vehicleStatusId: string;
    public vehicleStatusDesc: string;
    public vehicleStatusSupId: string;
    public companyId: string;
    public regExpiryDate: Date;
    public adminFlagsRoadUserChargesOutstanding: boolean;
    public adminFlagsRoadUserChargesApply: boolean;
    public roadUserEnd: number;
    public cofExpiryDate: Date;
    public comment: string;
    public orcPriceAmount: number;
    public orcPriceTaxStatusEnum: number;
    public orcPriceTaxAmount: number;
    public adminFlagsDisableFinance: boolean;
    public retailPriceAmount: number;
    public retailPriceTaxStatusEnum: number;
    public retailPriceTaxAmount: number;
    public specialPriceAmount: number;
    public specialPriceTaxStatusEnum: number;
    public specialPriceTaxAmount: number;
    public wholesalePriceAmount: number;
    public wholesalePriceTaxStatusEnum: number;
    public wholesalePriceTaxAmount: number;
    public adminFlagsIncludeGroups: boolean;
    public vehicleGroupIds: string[];
    public forceStatusHistorySave: boolean;
    public priceTaxRate: number;
    public buyAtGateFees: number;
    public buyAtGateFinanceOwing: number;
    public buyAtGateFinancier: string;
    public buyAtGateVendorBankAcc: string;
    public mediumDesc: string;

    //sideload objects
    public vehicleStatus: LookupModel;
    public vehicleStatusSup: ContactResultModel;
    public company: ContactResultModel;

    public retailPriceTaxStatus: TaxStatusModel;
    public specialPriceTaxStatus: TaxStatusModel;
    public orcPriceTaxStatus: TaxStatusModel;
    public wholesalePriceTaxStatus: TaxStatusModel;
    public vehicleGroups: LookupModel[];

}
export class VehicleModel
{
    public vehicleClass: VehicleClass;
    public id: string;

    public vehicleGeneral: VehicleGeneralModel;
    public vehicleExpenses: VehicleExpensesModel;
    public vehiclePurchase: VehiclePurchaseModel;
    public vehicleInterior: VehicleInteriorModel;
    public vehicleExterior: VehicleExteriorModel;
    public vehicleMechanical: VehicleMechanicalModel;
    public vehicleExport: VehicleExportModel;
    public vehicleAdmin: VehicleAdminModel;
    public vehicleImages: VehicleImagesModel;
    public vehicleActivities: VehicleActivitiesModel;
    public vehiclePurchaseOrders: PurchaseOrdersModel;
    public vehicleSummary: VehicleSummaryModel;
    public vehicleLockStatus: VehicleLockStatusModel;
    public vehicleCustomFields: VehicleCustomFieldsModel;    
    
}

export class VehicleImagesModel
{
    public vehicleId: string;
    public images: VehicleImageModel[];
    public overlay1Id: string;
    public overlay1: LookupExtImageModel;
    public overlay2Id: string;
    public overlay2: LookupExtImageModel;
    public caption: string;
    public youTubeId: string;
}

export class VehicleActivitiesModel
{
    public vehicleId: string;
    public activities: OpportunityActivityResultModel[];
}

export class PurchaseOrdersModel
{
    public vehicleId: string;
    public purchaseOrders: PurchaseOrderResultModel[];
}

export class VehicleSummaryModel
{
    public vehicleId: string;
    public vehicleClass: number;

    public effectiveRetailPriceTaxStatusDisplay: string;
    public stockNo: string;
    public manuYear: number;
    public yearManuModelCaption: string;
    public manuModelCaption: string;
    public companyCode: string;
    public regNo: string;
    public fuelTypeCaption: string;
    public fuelTypeCode: string;
    public fuelTypeParent: string;
    public extColorCaption: string;
    public intColorCaption: string;
    public vin: string;
    public chassisNo: string;
    public odometerCaption: string;
    public transmissionCaption: string;
    public transmissionCode: string;
    public transmissionParent: string;
    public engineSizeCaption: string;
    public vehicleStatusCaption: string;
    public vehicleStatusElapsedDays: number;
    public vehicleStatusDisplay: string;
    public vehicleStatusId: string;
    public vehicleStatus: LookupModel;
    public vehicleStatusDesc: string;
    public vehicleStatusSupId: string;
    public vehicleStatusSupCaption: string;
    public vehicleThumbnailId: string;
    public vehicleThumbnailModified: Date;
    public vehicleThumbnailUrl: string;
    public isSpecial: boolean;
    public isActive: boolean;
    public effectivePriceAmount: number;
    public effectivePriceTaxStatusDisplay: string;
    effectivePriceTaxStatusEnum: TaxStatusEnum;
    public effectiveRetailPriceDisplay: string;
    public retailPriceAmount: number;
    public specialPriceAmount: number;
    public wholesalePriceAmount: number;
    public orcPriceAmount: number;
    public salePriceAmount: number;
    public retailPriceTaxStatusEnum: number;
    public specialPriceTaxStatusEnum: number;
    public orcPriceTaxStatusEnum: number;
    public wholesalePriceTaxStatusEnum: number;
    public salePriceTaxStatusEnum: number;
    public vinChassisShortCaption: string;
    public opportunityCount: number;
    public vehicleImageId: string;
    public vehicleImageUrl: string;
    public bodyStyleCaption: string;

    public createdDate: Date;
    public modifiedDate: Date;

    public dealershipId: string;

	public EffectivePriceTaxStatus: TaxStatusModel;
	public RetailPriceTaxStatus: TaxStatusModel;
	public SpecialPriceTaxStatus: TaxStatusModel;
	public WholesalePriceTaxStatus: TaxStatusModel;
	public ORCPriceTaxStatus: TaxStatusModel;

    customField1: string;
	customField2: string;
	customField3: string;
	customField4: string;
	customField5: string;
	customField6: string;
	customField7: string;
	customField8: string;
	customField9: string;
	customField10: string;
	customField11: string;
	customField12: string;
}


export class VehicleFeaturesModel
{
    public exteriorFeatureIds: string[];

    public interiorFeatureIds: string[];

    public mechanicalFeatureIds: string[];
}

export class VehicleCustomFieldsModel
{
    public vehicleId: string;
    public vehicleClass: VehicleClass;

    customField1: string;
    customField2: string;
    customField3: string;
    customField4: string;
    customField5: string;
    customField6: string;
    customField7: string;
    customField8: string;
    customField9: string;
    customField10: string;
    customField11: string;
    customField12: string;
    
    customField1_Object: CustomFieldResultModel;
    customField2_Object: CustomFieldResultModel;
    customField3_Object: CustomFieldResultModel;
    customField4_Object: CustomFieldResultModel;
    customField5_Object: CustomFieldResultModel;
    customField6_Object: CustomFieldResultModel;
    customField7_Object: CustomFieldResultModel;
    customField8_Object: CustomFieldResultModel;
    customField9_Object: CustomFieldResultModel;
    customField10_Object: CustomFieldResultModel;
    customField11_Object: CustomFieldResultModel;
    customField12_Object: CustomFieldResultModel;
}